import { createContext, useContext } from 'react';
export const WeekNavContext = createContext(null);
export function useWeekNav() { return useContext(WeekNavContext); }
